import React, { useState, useCallback, useEffect } from "react";

import { Doughnut } from "react-chartjs-2";
import * as userActions from "../../../../../actions/index";
import Heading from "../../../../../common/element/Heading";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
import Table from "../../../../../common/element/Table";
import Segment from "../../../../../common/element/Segment";
import PieChart from "./PieChart";
import Tag from "../../../../../common/element/Tag";
import DatePicker from "../../../../../common/element/DatePicker";
import { setBreadcrumbs } from "../../../../../redux/classes/breadcrumbsSlice";
import { Link } from "react-router-dom";
import useUnauthorizedHandler from "../../../../../common/snippet/useUnauthorizedHandler";
// import { DashboardGetAllClientsStatusChart } from "../../../../../actions/Admin-Client/AllSiteApi";
import { updateRoutefunc } from "../../../../../redux/classes/common/updateRoute";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import Invoices from "../Invoices";
import { AdminGetWorkerDashboardDetails, AdminGetProviderDashboardDetails, AdminGetClientDashboardDetails } from "../../../../../actions/Admin/DashboardApis";
ChartJS.register(ArcElement, Tooltip, Legend);
const Dashboard = (props) => {
  const [singleSegmentValue, setSingleSegmentValue] = useState(["All"]);
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [functionId, setfunctionId] = useState("");
  const [providerFunctionId, setProviderfunctionId] = useState("")
  const [file, setFile] = useState("");
  const [clientData, setClientData] = useState(null);
  const AllFunctions = useSelector((state) => state.allFunctions);
  const [workerCounts, setWorkerCounts] = useState([])
  const [providerCounts, setProviderCounts] = useState([])
  const [clientCounts, setClientCounts] = useState([])
  useEffect(() => {
    if (AllFunctions?.allFunction) {
      let functionType = AllFunctions?.allFunction.filter(
        (item) => item?.function_name === "client" // client function id 
      );
      setfunctionId(functionType[0]?.function_id);
    }
    if (AllFunctions?.allFunction) {
      let functionType = AllFunctions?.allFunction.filter(
        (item) => item?.function_name === "provider" // client function id 
      );
      setProviderfunctionId(functionType[0]?.function_id);
    }
  }, []);

  let organisation_id;
  let permission_data;
  const permissionData = JSON.parse(localStorage?.getItem("permission_data"));

  if (permissionData !== null) {
    permission_data = permissionData;
    organisation_id = permissionData?.data?.organisation_id;
  }

  const { Tr, Th, Td, THead, TBody } = Table;
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Dashboard",
          url: "/admin/dashboard",
          home: "/admin/dashboard",
        },
      ])
    );
  }, []);

  // const data = {
  //   labels: [
  //     `Active ${clientData?.activeCount || 0}`,
  //     // `Deactivated ${clientData?.inactiveCount || 0}`,
  //   ],
  //   datasets: [
  //     {
  //       label: "Client Status",
  //       data: [
  //         Number(clientData?.activeCount || 0),
  //         // Number(clientData?.inactiveCount || 0),
  //       ],
  //       backgroundColor: ["#86E5B2", "#FDA29B"],
  //       hoverOffset: 4,
  //       borderWidth: 0,
  //     },
  //   ],
  // };

  // const options = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       // display: true,
  //       position: "right",
  //       labels: {
  //         boxWidth: 10,
  //         padding: 20,
  //         borderWidth: 1,
  //         usePointStyle: true, // Add this line to make legend circles
  //       },
  //       cutout: "60%",
  //     },
  //   },
  // };

  // // Custom plugin to draw text in the center
  // const centerTextPlugin = {
  //   id: "centerText",
  //   beforeDraw: (chart) => {
  //     const {
  //       ctx,
  //       data,
  //       chartArea: { width, height },
  //     } = chart;
  //     ctx.save();
  //     // Convert data to numbers and calculate the total
  //     const total = data.datasets[0].data.reduce(
  //       (acc, value) => acc + Number(value),
  //       0
  //     );

  //     // Text settings for the total number
  //     ctx.font = "bold 20px Arial";
  //     ctx.fillStyle = "#1D2939";
  //     ctx.textAlign = "center";
  //     ctx.textBaseline = "middle";

  //     // Draw the total number
  //     ctx.fillText(`${total}`, width / 2, height / 2 - 10);

  //     // Text settings for "Clients"
  //     ctx.font = "13px Arial"; // Regular font with 10px size
  //     ctx.fillText("Clients", width / 2, height / 2 + 10);

  //     ctx.restore();
  //   },
  // };

  const GetAdminGetProviderDashboardDetails = useCallback(() => {
    if (providerFunctionId) {
      const payload = { function_id: providerFunctionId }
      dispatch(AdminGetProviderDashboardDetails(payload))
        .then((response) => {
          if (response.success) {
            setProviderCounts(response?.data);

          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => {
          // Handle error here
          console.error("Error fetching client data: ", error);
        });
    }

  }, [dispatch, providerFunctionId]);

  const GetAdminGetWorkerDashboardDetails = useCallback(() => {
    dispatch(AdminGetWorkerDashboardDetails())
      .then((response) => {
        if (response.success) {
          setWorkerCounts(response?.data);

        } else if (response.status === 401) {
          handleUnauthorizedAccess();
        }
      })
      .catch((error) => {
        // Handle error here
        console.error("Error fetching client data: ", error);
      });

  }, [dispatch]);

  const GetAdminGetClientDashboardDetails = useCallback(() => {
    if (functionId) {
      const payload = { function_id: functionId } // client function id
      dispatch(AdminGetClientDashboardDetails(payload))
        .then((response) => {
          if (response.success) {
            setClientCounts(response?.data?.[0]);

          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => {
          // Handle error here
          console.error("Error fetching client data: ", error);
        });
    }

  }, [dispatch, functionId]);


  useEffect(() => {
    GetAdminGetClientDashboardDetails()
  }, [functionId])
  useEffect(() => {
    GetAdminGetProviderDashboardDetails();
  }, [providerFunctionId])

  useEffect(() => {
    GetAdminGetWorkerDashboardDetails()
  }, []);

  // const fetchDashboardAllClientsDoughnut = useCallback(() => {
  //   if (functionId) {
  //     dispatch(DashboardGetAllClientsStatusChart({ function_id: functionId }))
  //       .then((response) => {
  //         if (response.success) {
  //           setClientData(response?.data);
  //         } else if (response.status === 401) {
  //           handleUnauthorizedAccess();
  //         }
  //       })
  //       .catch((error) => {
  //         // Handle error here
  //         console.error("Error fetching client data: ", error);
  //       });
  //   }
  // }, [dispatch, functionId]);

  // useEffect(() => {
  //   fetchDashboardAllClientsDoughnut();
  // }, [fetchDashboardAllClientsDoughnut]);


  const UpdateRoute = () => {
    dispatch(updateRoutefunc(true));
  };

  return (
    <React.Fragment>
      <Heading className="mb-4">Dashboard</Heading>

      <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-8">
        <div className="flex gap-3 flex-col">
          <div className="bg-white p-6 border border-gray-200 rounded-xl dark-shadow h-full">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5">
              <span className="text-gray-900 text-base font-semibold flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M18.6695 4.84647L18.6696 4.84648C19.0667 4.91279 19.3578 5.2563 19.3578 5.65874V18.6823C19.3578 19.1371 18.9894 19.5058 18.5344 19.5058H12.7461C12.2915 19.5058 11.9227 19.1367 11.9227 18.6823C11.9227 18.2278 12.2915 17.8587 12.7461 17.8587H17.711L17.711 6.35648L10.6754 5.18397V18.6823C10.6754 19.1367 10.3067 19.5058 9.85198 19.5058C9.39734 19.5058 9.02867 19.1367 9.02867 18.6823V4.21176C9.02867 3.96961 9.13503 3.73994 9.31975 3.58353C9.50435 3.42699 9.74874 3.3597 9.98728 3.39948C9.98729 3.39948 9.98729 3.39948 9.98729 3.39948L18.6695 4.84647Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.9222 15.0647C11.9222 14.6098 12.2906 14.2413 12.7456 14.2413H15.6397C16.0948 14.2413 16.4633 14.6098 16.4633 15.0647V18.6824C16.4633 19.1373 16.0948 19.5059 15.6397 19.5059H12.7456C12.2906 19.5059 11.9222 19.1373 11.9222 18.6824V15.0647ZM13.5692 17.8589H14.8163V15.8883H13.5692V17.8589Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.24247 15.0647C3.24247 14.6098 3.6111 14.2413 4.06602 14.2413H6.96016C7.41511 14.2413 7.78359 14.6098 7.78359 15.0647V18.6824C7.78359 19.1373 7.41513 19.5059 6.96016 19.5059H4.06602C3.61107 19.5059 3.24247 19.1373 3.24247 18.6824V15.0647ZM4.88961 17.8589H6.1366V15.8883H4.88961V17.8589Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M1.30371 0.505331L1.30382 0.505348L9.98607 1.95258C10.3831 2.01877 10.6742 2.36218 10.6742 2.76485V18.6824C10.6742 19.1372 10.3059 19.5058 9.85079 19.5058H4.06252C3.60789 19.5058 3.2392 19.1367 3.2392 18.6824C3.2392 18.2281 3.60789 17.8589 4.06252 17.8589H9.02744L9.02751 3.46259L1.99195 2.28983V18.6824C1.99195 19.1367 1.62326 19.5059 1.16863 19.5059C0.713896 19.5059 0.345201 19.1367 0.345201 18.6824V1.31762C0.345201 1.07549 0.451765 0.846099 0.636275 0.68964C0.820964 0.532789 1.06534 0.465851 1.30371 0.505331Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M14.8163 11.0854C14.8163 10.8305 15.023 10.6236 15.2779 10.6236H16.0015C16.2565 10.6236 16.4633 10.8304 16.4633 11.0854V11.809C16.4633 12.0638 16.2565 12.2708 16.0015 12.2708H15.2779C15.023 12.2708 14.8163 12.0638 14.8163 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.9217 11.0854C11.9217 10.8305 12.1285 10.6236 12.3835 10.6236H13.107C13.3619 10.6236 13.5688 10.8304 13.5688 11.0854V11.809C13.5688 12.0638 13.362 12.2708 13.107 12.2708H12.3835C12.1285 12.2708 11.9217 12.0638 11.9217 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.9217 8.19138C11.9217 7.93656 12.1285 7.72959 12.3835 7.72959H13.107C13.3619 7.72959 13.5688 7.93654 13.5688 8.19138V8.91494C13.5688 9.16977 13.362 9.37673 13.107 9.37673H12.3835C12.1285 9.37673 11.9217 9.16978 11.9217 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M14.8163 8.19138C14.8163 7.93658 15.023 7.72959 15.2779 7.72959H16.0015C16.2565 7.72959 16.4633 7.93654 16.4633 8.19138V8.91494C16.4633 9.16977 16.2565 9.37673 16.0015 9.37673H15.2779C15.023 9.37673 14.8163 9.16976 14.8163 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M6.13657 11.0854C6.13657 10.8305 6.34338 10.6236 6.59837 10.6236H7.32192C7.57679 10.6236 7.78359 10.8305 7.78359 11.0854V11.809C7.78359 12.0638 7.57683 12.2708 7.32192 12.2708H6.59837C6.34338 12.2708 6.13657 12.0638 6.13657 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.24192 11.0854C3.24192 10.8305 3.44873 10.6236 3.70371 10.6236H4.42727C4.68209 10.6236 4.88906 10.8304 4.88906 11.0854V11.809C4.88906 12.0638 4.68213 12.2708 4.42727 12.2708H3.70371C3.44872 12.2708 3.24192 12.0638 3.24192 11.809V11.0854Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.24192 8.19138C3.24192 7.93656 3.44871 7.72959 3.70371 7.72959H4.42727C4.68211 7.72959 4.88906 7.93652 4.88906 8.19138V8.91494C4.88906 9.16979 4.68213 9.37673 4.42727 9.37673H3.70371C3.44872 9.37673 3.24192 9.16978 3.24192 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M6.13657 8.19138C6.13657 7.93656 6.34336 7.72959 6.59837 7.72959H7.32192C7.57681 7.72959 7.78359 7.93657 7.78359 8.19138V8.91494C7.78359 9.16974 7.57683 9.37673 7.32192 9.37673H6.59837C6.34338 9.37673 6.13657 9.16978 6.13657 8.91494V8.19138Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M6.13657 5.29734C6.13657 5.04252 6.34336 4.83555 6.59837 4.83555H7.32192C7.57681 4.83555 7.78359 5.04252 7.78359 5.29734V6.0209C7.78359 6.27584 7.5768 6.48269 7.32192 6.48269H6.59837C6.3434 6.48269 6.13657 6.27588 6.13657 6.0209V5.29734Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                    <path
                      d="M3.24192 5.29734C3.24192 5.04252 3.44871 4.83555 3.70371 4.83555H4.42727C4.68211 4.83555 4.88906 5.04248 4.88906 5.29734V6.0209C4.88906 6.27588 4.68211 6.48269 4.42727 6.48269H3.70371C3.44875 6.48269 3.24192 6.27588 3.24192 6.0209V5.29734Z"
                      fill="#101828"
                      stroke="#101828"
                      stroke-width="0.2"
                    />
                  </svg>
                </span>
                Total Clients
              </span>
              <BtnLight className="w-20 h-9" onClick={() => UpdateRoute()}>
                <Link to={"/admin/client/view-all-clients"}>View All</Link>{" "}
              </BtnLight>
            </div>
            <div style={{ position: "relative", }} className="card-body mt-[34px]">
              <PieChart chartData={clientCounts} title={"Clients"} />

            </div>
          </div>
        </div>
        <div className="flex gap-3 flex-col">
          <div className="bg-white p-6 border border-gray-200 rounded-xl dark-shadow h-full">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5">
              <span className="text-gray-900 text-base font-semibold flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M19.6853 20.8745C20.4904 20.8745 21.141 20.2225 21.141 19.4191V15.5467C21.141 14.7434 20.4904 14.0914 19.6853 14.0914H13.8752C13.0701 14.0914 12.4195 14.7434 12.4195 15.5467V19.4191C12.4195 20.2225 13.0701 20.8745 13.8752 20.8745H19.6853ZM19.6853 19.5128H13.8752C13.8235 19.5128 13.7815 19.4707 13.7815 19.4191V15.5467C13.7815 15.4951 13.8235 15.4531 13.8752 15.4531H19.6853C19.737 15.4531 19.779 15.4951 19.779 15.5467V19.4191C19.779 19.4707 19.737 19.5128 19.6853 19.5128Z"
                      fill="#1D2939"
                      stroke="#1D2939"
                      stroke-width="0.2"
                    />
                    <path
                      d="M19.7789 15.5458C19.7789 16.0251 19.3898 16.4141 18.9105 16.4141H14.6499C14.1706 16.4141 13.7815 16.0251 13.7815 15.5458C13.7815 15.1699 13.4765 14.8648 13.1005 14.8648C12.7246 14.8648 12.4195 15.1699 12.4195 15.5458C12.4195 16.7769 13.4187 17.7761 14.6499 17.7761H18.9105C20.1417 17.7761 21.1409 16.7769 21.1409 15.5458C21.1409 15.1699 20.8358 14.8648 20.4599 14.8648C20.0839 14.8648 19.7789 15.1699 19.7789 15.5458Z"
                      fill="#1D2939"
                      stroke="#1D2939"
                      stroke-width="0.2"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M18.3281 14.889C18.6488 14.889 18.9091 14.6287 18.9091 14.308V13.5333C18.9091 12.785 18.3033 12.1777 17.5534 12.1777H16.0041C15.2543 12.1777 14.6484 12.785 14.6484 13.5333V14.308C14.6484 14.6287 14.9087 14.889 15.2294 14.889H18.3281ZM17.7471 13.8727H15.8104V13.5333C15.8104 13.4265 15.8972 13.3397 16.0041 13.3397H17.5534C17.6603 13.3397 17.7471 13.4265 17.7471 13.5333V13.8727Z"
                      fill="#1D2939"
                      stroke="#1D2939"
                      stroke-width="0.2"
                    />
                    <path
                      d="M11.3005 14.0664C9.42367 14.098 5.85538 14.7346 4.08087 18.5573C3.86891 19.0142 3.9053 19.737 5.25078 19.776C6.59626 19.815 9.12651 19.7923 10.6865 19.776"
                      stroke="#1D2939"
                      stroke-width="1.95"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <circle
                      cx="12.0903"
                      cy="7.90674"
                      r="3.75986"
                      stroke="#1D2939"
                      stroke-width="1.95"
                    />
                  </svg>
                </span>
                Total Providers
              </span>
              <BtnLight className="w-20 h-9" onClick={() => UpdateRoute()}>
                <Link to={"/admin/provider/view-all-provider"}>View All</Link>
              </BtnLight>
            </div>
            <div style={{ position: "relative", }} className="card-body mt-[34px]">
              <PieChart chartData={providerCounts} title={"Providers"} />
            </div>
          </div>
        </div>
        <div className="flex gap-3 flex-col">
          <div className="bg-white p-6 border border-gray-200 rounded-xl dark-shadow h-full">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5">
              <span className="text-gray-900 text-base font-semibold flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M17.4918 21.4389H6.87332C5.73479 21.4389 4.80859 20.5128 4.80859 19.3742V4.62625C4.80859 3.48772 5.73474 2.56152 6.87332 2.56152H17.492C18.6305 2.56152 19.5567 3.48773 19.5567 4.62625V19.3742C19.5567 20.5127 18.6304 21.4389 17.4918 21.4389ZM17.7867 4.62592C17.7867 4.46308 17.654 4.33094 17.4918 4.33094H6.87332C6.71108 4.33094 6.57835 4.46309 6.57835 4.62592C6.57835 20.0499 6.41375 19.6689 6.87327 19.6689C17.811 19.6689 17.7868 19.8564 17.7868 19.3739L17.7867 4.62592Z"
                      fill="#1D2939"
                    />
                    <path
                      d="M13.6571 6.98594H10.7075C10.2191 6.98594 9.82263 6.59008 9.82263 6.10106C9.82263 5.61203 10.2191 5.21619 10.7075 5.21619H13.6571C14.1455 5.21619 14.542 5.61205 14.542 6.10106C14.542 6.59009 14.1455 6.98594 13.6571 6.98594Z"
                      fill="#1D2939"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.1833 9.56846C11.3273 9.56846 10.6333 10.2624 10.6333 11.1185C10.6333 11.9745 11.3273 12.6685 12.1833 12.6685C13.0394 12.6685 13.7333 11.9745 13.7333 11.1185C13.7333 10.2624 13.0394 9.56846 12.1833 9.56846ZM9.23333 11.1185C9.23333 9.48922 10.5541 8.16846 12.1833 8.16846C13.8126 8.16846 15.1333 9.48922 15.1333 11.1185C15.1333 12.7477 13.8126 14.0685 12.1833 14.0685C10.5541 14.0685 9.23333 12.7477 9.23333 11.1185ZM8.90778 17.1685H15.4589C14.6845 16.189 13.5033 15.5685 12.1833 15.5685C10.8634 15.5685 9.68216 16.189 8.90778 17.1685ZM7.73283 16.3994C8.75495 15.0467 10.3666 14.1685 12.1833 14.1685C14.0001 14.1685 15.6117 15.0467 16.6338 16.3994C16.639 16.4063 16.6443 16.4133 16.6496 16.4203C16.7321 16.5293 16.831 16.66 16.903 16.7885C16.9939 16.9509 17.0662 17.1483 17.0618 17.3904C17.0582 17.5861 16.9995 17.764 16.9314 17.9008C16.8633 18.0375 16.7568 18.1917 16.6028 18.3125C16.3967 18.4743 16.1751 18.5284 15.9938 18.5501C15.8401 18.5686 15.6612 18.5685 15.4973 18.5685C15.4881 18.5685 15.4789 18.5685 15.4697 18.5685H8.89694C8.8878 18.5685 8.87861 18.5685 8.86936 18.5685C8.70546 18.5685 8.52661 18.5686 8.37283 18.5501C8.19162 18.5284 7.97001 18.4743 7.76387 18.3125C7.60991 18.1917 7.50333 18.0375 7.43527 17.9008C7.36721 17.764 7.30846 17.5861 7.30488 17.3904C7.30045 17.1483 7.37274 16.9509 7.46372 16.7885C7.53571 16.66 7.63459 16.5293 7.71703 16.4203C7.72237 16.4133 7.72764 16.4063 7.73283 16.3994Z"
                      fill="#1D2939"
                    />
                    <path
                      d="M15.4589 17.1685V17.2685C15.4972 17.2685 15.5322 17.2465 15.5489 17.212C15.5656 17.1775 15.5611 17.1365 15.5373 17.1064L15.4589 17.1685ZM8.90778 17.1685L8.82933 17.1064C8.80556 17.1365 8.80107 17.1775 8.81777 17.212C8.83448 17.2465 8.86944 17.2685 8.90778 17.2685V17.1685ZM7.73283 16.3994L7.65304 16.3392H7.65304L7.73283 16.3994ZM16.6338 16.3994L16.5541 16.4597L16.5541 16.4597L16.6338 16.3994ZM16.6496 16.4203L16.5699 16.4807L16.5699 16.4807L16.6496 16.4203ZM16.903 16.7885L16.9902 16.7396L16.903 16.7885ZM17.0618 17.3904L16.9618 17.3886V17.3886L17.0618 17.3904ZM16.6028 18.3125L16.6645 18.3912L16.6028 18.3125ZM15.9938 18.5501L15.9819 18.4509L15.9938 18.5501ZM15.4973 18.5685L15.4973 18.6685H15.4973L15.4973 18.5685ZM8.86936 18.5685L8.8694 18.6685H8.86941L8.86936 18.5685ZM8.37283 18.5501L8.38474 18.4509H8.38474L8.37283 18.5501ZM7.76387 18.3125L7.8256 18.2338H7.8256L7.76387 18.3125ZM7.30488 17.3904L7.40486 17.3886L7.30488 17.3904ZM7.46372 16.7885L7.55096 16.8374H7.55096L7.46372 16.7885ZM7.71703 16.4203L7.63728 16.36L7.63728 16.36L7.71703 16.4203ZM10.7333 11.1185C10.7333 10.3176 11.3825 9.66846 12.1833 9.66846V9.46846C11.2721 9.46846 10.5333 10.2072 10.5333 11.1185H10.7333ZM12.1833 12.5685C11.3825 12.5685 10.7333 11.9193 10.7333 11.1185H10.5333C10.5333 12.0297 11.2721 12.7685 12.1833 12.7685V12.5685ZM13.6333 11.1185C13.6333 11.9193 12.9842 12.5685 12.1833 12.5685V12.7685C13.0946 12.7685 13.8333 12.0297 13.8333 11.1185H13.6333ZM12.1833 9.66846C12.9842 9.66846 13.6333 10.3176 13.6333 11.1185H13.8333C13.8333 10.2072 13.0946 9.46846 12.1833 9.46846V9.66846ZM12.1833 8.06846C10.4989 8.06846 9.13333 9.43399 9.13333 11.1185H9.33333C9.33333 9.54444 10.6093 8.26846 12.1833 8.26846V8.06846ZM15.2333 11.1185C15.2333 9.43399 13.8678 8.06846 12.1833 8.06846V8.26846C13.7574 8.26846 15.0333 9.54444 15.0333 11.1185H15.2333ZM12.1833 14.1685C13.8678 14.1685 15.2333 12.8029 15.2333 11.1185H15.0333C15.0333 12.6925 13.7574 13.9685 12.1833 13.9685V14.1685ZM9.13333 11.1185C9.13333 12.8029 10.4989 14.1685 12.1833 14.1685V13.9685C10.6093 13.9685 9.33333 12.6925 9.33333 11.1185H9.13333ZM15.4589 17.0685H8.90778V17.2685H15.4589V17.0685ZM12.1833 15.6685C13.471 15.6685 14.624 16.2737 15.3805 17.2305L15.5373 17.1064C14.7451 16.1044 13.5355 15.4685 12.1833 15.4685V15.6685ZM8.98622 17.2305C9.74269 16.2737 10.8956 15.6685 12.1833 15.6685V15.4685C10.8312 15.4685 9.62163 16.1044 8.82933 17.1064L8.98622 17.2305ZM12.1833 14.0685C10.3334 14.0685 8.69297 14.9629 7.65304 16.3392L7.81261 16.4597C8.81693 15.1306 10.3997 14.2685 12.1833 14.2685V14.0685ZM16.7136 16.3392C15.6737 14.9629 14.0332 14.0685 12.1833 14.0685V14.2685C13.967 14.2685 15.5498 15.1306 16.5541 16.4597L16.7136 16.3392ZM16.7294 16.36C16.724 16.3529 16.7188 16.346 16.7136 16.3392L16.5541 16.4597C16.5593 16.4666 16.5646 16.4736 16.5699 16.4807L16.7294 16.36ZM16.9902 16.7396C16.9143 16.604 16.811 16.4678 16.7294 16.36L16.5699 16.4807C16.6532 16.5908 16.7477 16.7159 16.8157 16.8374L16.9902 16.7396ZM17.1618 17.3922C17.1666 17.1279 17.0873 16.913 16.9902 16.7396L16.8157 16.8374C16.9006 16.9889 16.9658 17.1688 16.9618 17.3886L17.1618 17.3922ZM17.0209 17.9453C17.0938 17.799 17.1579 17.6063 17.1618 17.3922L16.9618 17.3886C16.9586 17.5658 16.9051 17.7291 16.8419 17.8562L17.0209 17.9453ZM16.6645 18.3912C16.833 18.259 16.9481 18.0917 17.0209 17.9453L16.8419 17.8562C16.7786 17.9833 16.6805 18.1244 16.5411 18.2338L16.6645 18.3912ZM16.0058 18.6494C16.1969 18.6265 16.4386 18.5684 16.6645 18.3912L16.5411 18.2338C16.3547 18.3801 16.1532 18.4303 15.9819 18.4509L16.0058 18.6494ZM15.4973 18.6685C15.6597 18.6685 15.8449 18.6687 16.0058 18.6494L15.9819 18.4509C15.8353 18.4684 15.6628 18.4685 15.4973 18.4685L15.4973 18.6685ZM15.4697 18.6685C15.4789 18.6685 15.488 18.6685 15.4973 18.6685L15.4974 18.4685C15.4881 18.4685 15.4789 18.4685 15.4697 18.4685V18.6685ZM8.89694 18.6685H15.4697V18.4685H8.89694V18.6685ZM8.86941 18.6685C8.87865 18.6685 8.88783 18.6685 8.89694 18.6685V18.4685C8.88778 18.4685 8.87856 18.4685 8.86932 18.4685L8.86941 18.6685ZM8.36092 18.6494C8.5218 18.6687 8.70701 18.6685 8.8694 18.6685L8.86933 18.4685C8.7039 18.4685 8.53141 18.4684 8.38474 18.4509L8.36092 18.6494ZM7.70213 18.3912C7.92804 18.5684 8.16975 18.6265 8.36092 18.6494L8.38474 18.4509C8.2135 18.4303 8.01199 18.3801 7.8256 18.2338L7.70213 18.3912ZM7.34575 17.9453C7.41861 18.0917 7.53366 18.259 7.70213 18.3912L7.8256 18.2338C7.68615 18.1244 7.58805 17.9833 7.52479 17.8562L7.34575 17.9453ZM7.2049 17.3922C7.20881 17.6063 7.27288 17.799 7.34575 17.9453L7.52479 17.8562C7.46153 17.7291 7.40811 17.5658 7.40486 17.3886L7.2049 17.3922ZM7.37647 16.7396C7.27937 16.913 7.20006 17.1279 7.2049 17.3922L7.40486 17.3886C7.40084 17.1688 7.46611 16.9889 7.55096 16.8374L7.37647 16.7396ZM7.63728 16.36C7.55569 16.4678 7.45242 16.604 7.37647 16.7396L7.55096 16.8374C7.619 16.7159 7.71348 16.5908 7.79678 16.4807L7.63728 16.36ZM7.65304 16.3392C7.64788 16.346 7.64263 16.3529 7.63728 16.36L7.79677 16.4807C7.8021 16.4736 7.8074 16.4666 7.81261 16.4597L7.65304 16.3392Z"
                      fill="#1D2939"
                    />
                  </svg>
                </span>
                Total Workers
              </span>
              <BtnLight className="w-20 h-9" onClick={() => UpdateRoute()}>
                <Link to={"/admin/worker/view-all-worker"}>View All</Link>{" "}
              </BtnLight>
            </div>
            <div style={{ position: "relative", }} className="card-body mt-[34px]">
              <PieChart chartData={workerCounts} title={"Workers"} />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-5 border border-gray-200 rounded-xl dark-shadow mt-7">
        <div className="card-header flex justify-between border-b border-gray-200 pb-5 px-5 mb-3">
          <span className="text-gray-900 text-base font-semibold flex items-center">
            <span className="mr-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M9.35156 14.6667C9.35156 15.9553 10.3962 17 11.6849 17H13.8516C15.2323 17 16.3516 15.8807 16.3516 14.5C16.3516 13.1193 15.2323 12 13.8516 12H11.8516C10.4709 12 9.35156 10.8807 9.35156 9.5C9.35156 8.11929 10.4709 7 11.8516 7H14.0182C15.3069 7 16.3516 8.04467 16.3516 9.33333M12.8516 5.5V7M12.8516 17V18.5M22.8516 12C22.8516 17.5228 18.3744 22 12.8516 22C7.32871 22 2.85156 17.5228 2.85156 12C2.85156 6.47715 7.32871 2 12.8516 2C18.3744 2 22.8516 6.47715 22.8516 12Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            Invoices
          </span>
          <BtnLight className="w-20 h-9" onClick={() => UpdateRoute()}>
            <Link to={"/admin/invoices"}>View All</Link>{" "}
          </BtnLight>
        </div>

        {/* <div className="flex justify-between my-3.5 px-4">
          <Segment
            className="docType-btn"
            value={singleSegmentValue}
            onChange={(val) => onSingleSelectionSegmentChange(val)}
          >
            <Segment.Item value="All">All</Segment.Item>
            <Segment.Item value="Insurance">Paid</Segment.Item>
            <Segment.Item value="Other">Overdue</Segment.Item>
            <Segment.Item value="Due soon">Due soon</Segment.Item>
          </Segment>
          <div className="w-80 h-10">
            <div className="input-wrapper">
              <div className="input-suffix-start left-3.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <path
                    d="M18.3516 17.5L15.435 14.5833M17.5182 9.58333C17.5182 13.4954 14.3469 16.6667 10.4349 16.6667C6.52288 16.6667 3.35156 13.4954 3.35156 9.58333C3.35156 5.67132 6.52288 2.5 10.4349 2.5C14.3469 2.5 17.5182 5.67132 17.5182 9.58333Z"
                    stroke="#667085"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <input
                type="text"
                name="hs-table-search"
                className="input  pl-11 w-full  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Search"
              />
            </div>
          </div>
        </div>
        <div className="px-4">
          <div className="overflow-hidden border rounded-lg border-gray-200">
            <Table>
              <THead>
                <Tr>
                  <Th>Name</Th>
                  <Th className="w-56">Type</Th>
                  <Th className="w-56">Amount</Th>
                  <Th className="w-64">Invoice sent</Th>
                  <Th className="w-64">Payment Date</Th>
                  <Th className="w-64">Status</Th>
                </Tr>
              </THead>
              <TBody>
                <Tr>
                  <Td>[Name of Recipient]</Td>
                  <Td>Provider</Td>
                  <Td>$000.00</Td>
                  <Td>DD/MM/YYYY</Td>
                  <Td>DD/MM/YYYY</Td>
                  <Td>
                    <Tag className="bg-success-100 text-success-700">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="12"
                          viewBox="0 0 13 12"
                          fill="none"
                        >
                          <path
                            d="M10.8516 3L5.35156 8.5L2.85156 6"
                            stroke="#3DB77E"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Paid
                    </Tag>
                  </Td>
                </Tr>
                <Tr>
                  <Td>[Name of Recipient]</Td>
                  <Td>Provider</Td>
                  <Td>$000.00</Td>
                  <Td>DD/MM/YYYY</Td>
                  <Td>DD/MM/YYYY</Td>
                  <Td>
                    <Tag className="bg-warning-100 text-warning-700">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="12"
                          viewBox="0 0 13 12"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_5799_40401)">
                            <path
                              d="M12.2015 5.75L11.2018 6.75L10.2015 5.75M11.3241 6.5C11.3422 6.33583 11.3516 6.169 11.3516 6C11.3516 3.51472 9.33684 1.5 6.85156 1.5C4.36628 1.5 2.35156 3.51472 2.35156 6C2.35156 8.48528 4.36628 10.5 6.85156 10.5C8.2652 10.5 9.52658 9.84817 10.3516 8.82867M6.85156 3.5V6L8.35156 7"
                              stroke="#F79009"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_5799_40401">
                              <rect
                                width="12"
                                height="12"
                                fill="white"
                                transform="translate(0.851562)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      Upcoming
                    </Tag>
                  </Td>
                </Tr>
                <Tr>
                  <Td>[Name of Recipient]</Td>
                  <Td>Provider</Td>
                  <Td>$000.00</Td>
                  <Td>
                    <span className="text-error-600">Due</span>
                  </Td>
                  <Td>DD/MM/YYYY</Td>
                  <Td>
                    <Tag className="bg-error-100 text-error-700">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="12"
                          viewBox="0 0 13 12"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_5799_40406)">
                            <path
                              d="M6.85156 4V6M6.85156 8H6.85656M1.85156 4.26137V7.73863C1.85156 7.86092 1.85156 7.92207 1.86538 7.97962C1.87763 8.03063 1.89783 8.07941 1.92524 8.12414C1.95616 8.1746 1.9994 8.21784 2.08588 8.30431L4.54725 10.7657C4.63372 10.8522 4.67696 10.8954 4.72742 10.9263C4.77216 10.9537 4.82093 10.9739 4.87195 10.9862C4.92949 11 4.99064 11 5.11293 11H8.59019C8.71249 11 8.77363 11 8.83118 10.9862C8.8822 10.9739 8.93097 10.9537 8.9757 10.9263C9.02616 10.8954 9.0694 10.8522 9.15588 10.7657L11.6172 8.30431C11.7037 8.21784 11.747 8.1746 11.7779 8.12414C11.8053 8.07941 11.8255 8.03063 11.8377 7.97962C11.8516 7.92207 11.8516 7.86092 11.8516 7.73863V4.26137C11.8516 4.13908 11.8516 4.07793 11.8377 4.02038C11.8255 3.96937 11.8053 3.92059 11.7779 3.87586C11.747 3.8254 11.7037 3.78216 11.6172 3.69569L9.15588 1.23431C9.0694 1.14784 9.02616 1.1046 8.9757 1.07368C8.93097 1.04627 8.8822 1.02606 8.83118 1.01382C8.77363 1 8.71249 1 8.59019 1H5.11293C4.99064 1 4.92949 1 4.87195 1.01382C4.82093 1.02606 4.77216 1.04627 4.72742 1.07368C4.67696 1.1046 4.63372 1.14784 4.54725 1.23431L2.08588 3.69569C1.9994 3.78216 1.95616 3.8254 1.92524 3.87586C1.89783 3.92059 1.87763 3.96937 1.86538 4.02038C1.85156 4.07793 1.85156 4.13908 1.85156 4.26137Z"
                              stroke="#F04438"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_5799_40406">
                              <rect
                                width="12"
                                height="12"
                                fill="white"
                                transform="translate(0.851562)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      Overdue
                    </Tag>
                  </Td>
                </Tr>
              </TBody>
            </Table>
          </div>
        </div> */}
        <Invoices dashboardStatus={true} />
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
